<template>
  <div class="notification-bar">
    <div class="title">
      <i class="fa fa-exclamation-circle" />
      <p>Your account is pending activation. Please submit your documents to <u>verify@hypto.in</u></p>
    </div>

    <div class="options">
      <button class="dark-btn" @click="openPopup('BlockedAccount')">Docs Required</button>
    </div>
  </div>
</template>

<script>
import { openPopup } from '@/utils/helpers'

export default {
  methods: {
    openPopup
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .notification-bar {
    @include custom-flex(space-between);
    background: $white;

    .title {
      @include custom-flex(flex-start);

      i {
        font-size: 18px;
        margin-right: 10px;
      }
      p {
        text-align: left;
      }
    }

    .options {
      display: flex;

      button {
        border-radius: 25px !important;
        white-space: nowrap;
        font-size: 13px !important;
      }
    }
  }

  .desktop {
    .notification-bar {
      border-radius: 25px;
      width: 100%;
      margin: 0 auto 15px;
      padding: 8px 15px;
      box-shadow: $lite-shadow;
      min-height: 50px;

      p {
        @include normal-text($secondary, 14px, 500);
      }

      button {
        margin-left: 10px;
      }
    }
  }

  .mobile, .tablet {
    .notification-bar {
      padding: 8px;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 10;
      box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 -3px 6px rgba(0,0,0,0.23);

      button {
        margin-left: 5px;
      }
    }
  }

  .mobile {
    .notification-bar {
      .options {
        flex-direction: column;

        button {
          padding: 10px 12px !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          margin: 2px 0 2px 4px;
        }
      }
    }
  }
</style>
